import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../library/checkbox/checkbox';

import './filter-option.scss';

function FilterOption(props) {
  const {
    categoryCode,
    categoryName,
    isSelected,
    label,
    onClick: propsOnClick,
    valueCode,
    valueName
  } = props;

  function onClick() {
    if (typeof propsOnClick === 'function') {
      propsOnClick({
        categoryCode,
        categoryName,
        type: 'option',
        valueCode,
        valueName
      });
    }
  }

  return (
    <li className="filter-option" styleName="option">
      <Checkbox
        id={`${valueCode}-checkbox`}
        isChecked={isSelected}
        label={label}
        onClick={onClick}
        readOnly
        value={valueCode}
      />
    </li>
  );
}

FilterOption.propTypes = {
  categoryCode: PropTypes.string,
  categoryName: PropTypes.string,
  isSelected: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  onClick: PropTypes.func,
  valueCode: PropTypes.string,
  valueName: PropTypes.string
};

export default FilterOption;
